import { Panel } from '@sdflc/ui';
import styled from 'styled-components';

export const StyledPanel = styled(Panel)`
  &:hover {
    background-color: #e3e7f3;
  }
`;
